var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const SKIP_NEXT = {};
export const SKIP_REQUEST = {};
function getConfig(config, configMap, defaultPriority) {
    const priority = config.priority;
    let targetConfig = Object.keys(config).filter((configName) => {
        return configName !== "priority" && configMap.has(configName);
    });
    if (priority) {
        targetConfig = targetConfig.sort((a, b) => {
            function formatPriority(num) {
                return typeof priority[num] === "number" ? priority[num] : defaultPriority;
            }
            return formatPriority(a) - formatPriority(b);
        });
    }
    return targetConfig.map((configName) => {
        const handler = configMap.get(configName);
        let resolve;
        let reject;
        if (handler) {
            resolve = "resolve" in handler ? handler === null || handler === void 0 ? void 0 : handler.resolve : typeof handler === "function" ? handler : undefined;
            reject = "reject" in handler ? handler.reject : undefined;
        }
        return {
            params: config[configName],
            resolve,
            reject,
        };
    });
}
export default {
    pre(config, configMap, initData, ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            if (config) {
                return getConfig(config, configMap, 50).reduce((pre, configHandler) => {
                    return pre.then((prevData) => {
                        if (configHandler.resolve) {
                            return configHandler.resolve(ctx, configHandler.params, prevData);
                        }
                        return prevData;
                    }, (error) => {
                        if (configHandler.reject) {
                            return configHandler.reject(ctx, configHandler.params, error);
                        }
                        return Promise.reject(error);
                    });
                }, Promise.resolve(initData));
            }
            return initData;
        });
    },
    post(config, configMap, initData, ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            if (config) {
                return getConfig(config, configMap, 50).reduce((pre, configHandler) => {
                    return pre.then((prevData) => {
                        if (configHandler.resolve) {
                            return configHandler.resolve(prevData, configHandler.params, ctx);
                        }
                        return prevData;
                    }, (error) => {
                        if (configHandler.reject) {
                            return configHandler.reject(error, configHandler.params, ctx);
                        }
                        return Promise.reject(error);
                    });
                }, initData);
            }
            return initData;
        });
    },
};
